import { render, staticRenderFns } from "./BatteryInformationComponent.vue?vue&type=template&id=40e0d294"
import script from "./BatteryInformationComponent.vue?vue&type=script&lang=ts"
export * from "./BatteryInformationComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports